import FieldDropdownLazyLoading from "../../../generic/dropdown-lazy-loading/dropdown-lazy-loading";
import FieldConfig from "../../../proto/field-config";
import FieldWebhookSelect_PopoverMenuMore from "./components/popover-menu-more";

/**
 * Webhook picker for the send-webhook action.
 *
 * The options come from the session (gd.session.getWebhooks()), which loads the
 * company's webhooks the first time anything asks for them and is kept current
 * by the server afterwards — so an opened form costs at most one request, and
 * usually none.
 */
export default class FieldWebhookSelect extends FieldDropdownLazyLoading {

    constructor(config:FieldConfig) {
        super(config);

        this.noValueOption  = false // the action is meaningless without a destination

        this._options       = null
        this.isLoaded       = false

        this.classes.PopoverMenu = "min-w-200"

        // the lazy-loading base disables it ("never show edit options") — here
        // it carries "Add webhook" at the bottom of the picker
        this.showMenuMore                   = true
        this.components.PopoverMenuMore     = FieldWebhookSelect_PopoverMenuMore
    }

    async loadOptions(callback?: callback): Promise<void> {

        // The session shares the in-flight request, which matters here: the
        // lazy-loading base calls this from render(), so it can fire again
        // before the first answer arrives.
        const webhooks = await gd.session.getWebhooks()

        this._options = webhooks.toOptions()
        this.isLoaded = true

        if (callback) callback()
    }

    // After the picker creates a webhook of its own. The cached options only
    // refill while `isLoaded` is false, so refetching the session is not enough
    // on its own — the cache has to be dropped with it.
    async reloadOptions(): Promise<void> {
        this.isLoaded = false
        this._options = null

        // the acting client must not wait for the server's reset event
        await gd.session.reloadWebhooks()
        await this.loadOptions()
    }

    getOptions() {
        return this._options || [];
    }

    // A webhook can be deleted while automations still point at it — the id is
    // stored but resolves to nothing. Only meaningful once the options are in.
    isMissing(webhookId?: ID): boolean {
        if (!webhookId || !this.isLoaded) return false

        return !_.find(this.getOptions(), (option:any) => option.value === webhookId)
    }
}
